import styled from 'styled-components';
import Banner from '../images/community.svg';
import { mediaQueries } from '../shared/config';
import CardsBundle from './CardsBundle';
import react, {useState, useEffect} from 'react';
import Banner_mobile from '../images/community_mobile.svg'; 

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    ${mediaQueries.tablet} {
        height: auto;
    }
    /* border: 1px solid black; */

`


const BannerContainer = styled.div`
    position: relative;
    color: black;
    /* background-image: url(${Banner}); */
    background-position: top;
    background-size: cover;
    width: 100%;
    /* min-height: 180px; */
    /* border: 1px solid blue; */
`
const Image = styled.img`
    position: relative;
    object-fit: fill;
    width: 100%;
`

const Header = styled.div`
    align-items: center;
    justify-content: center;
`

const TextContainer = styled.div`
    color: black;
    padding: 60px 10vw;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    /* border: 1px solid blue; */
`
const data = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.news.hispanicinstem.correa.EL.jpg",
        section: "NEWS",
        title: "Latino scientific researchers reflect on achievements, importance of mentorship",
        article_link: "https://dailybruin.com/2021/10/07/latino-scientific-researchers-reflect-on-achievements-importance-of-mentorship/",
        byline: "By Victoria Li",
        section_link: "https://dailybruin.com/category/news"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.news.hispanicstudentleaders.png",
        section: "NEWS",
        title: "Latina student leaders push UC to provide more resources for Latino students",
        article_link: "https://dailybruin.com/2021/10/07/latina-student-leaders-push-uc-to-provide-more-resources-for-latino-students/",
        byline: "By Chelsea Westman",
        section_link: "https://dailybruin.com/category/news"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.quad.hispanicactivismLA.jpeg",
        section: "THE QUAD",
        title: "Exploring the history of activism of Latino communities in LA",
        article_link: "https://dailybruin.com/2021/10/07/the-quad-exploring-the-history-of-activism-of-latino-communities-in-la/",
        byline: "By Avanthika Panchapakesan",
        section_link: "https://dailybruin.com/category/quad"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.sp.reyes.feat.png",
        section: "SPORTS",
        title: "UCLA women's soccer players swap colors, reach for Mexican roots in red and green",
        article_link: "https://dailybruin.com/2021/10/07/ucla-womens-soccer-players-swap-colors-reach-for-mexican-roots-in-red-and-green/",
        byline: "By Diego Farinha",
        section_link: "https://dailybruin.com/category/sports"

    }]

    const data2 = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/web.op.hhm.hispanicawareness.jpg",
        section: "OPINION",
        title: "Bruins should be more knowledgeable about Hispanic diversity",
        article_link: "https://dailybruin.com/2021/10/07/opinion-bruins-should-be-more-knowledgeable-about-hispanic-diversity/",
        byline: "By Diego Rivera",
        section_link: "https://dailybruin.com/category/opinion"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.grack.notablelatinobruins-01.png",
        section: "GRAPHIC",
        title: "Notable Latino Bruins",
        article_link: "https://dailybruin.com/2021/10/07/graphic-notable-latino-bruins/",
        byline: "By Alex Yoo and Maanas Oruganti",
        section_link: "https://dailybruin.com/category/graphics"
        

    }
]

const img = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/dancer1.gif",
        image_creds: "Ashley Kenney/Photo editor and Shirley Yao/Digital managing editor"
    }
]

const img2 = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/dancer2.gif",
        image_creds: "Ashley Kenney/Photo editor"
    }
]

export default function Community(props){
    const media = window.matchMedia('(max-width: 450px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    media.addEventListener('change', () => {
    if (media.matches !== isMobile) {
        setIsMobile(media.matches);
    }
    });
    return(
        <Container>
        <div name={props.name}>
            <BannerContainer>
                {!isMobile && <Image src={Banner} alt="Arts and culture"/>}
                {isMobile && <Image src={Banner_mobile} alt="Arts and culture"/>}
            </BannerContainer>
            </div>
            <TextContainer>
            Members of the UCLA community and beyond have been taking a stand and creating meaningful impacts. Read how current and past Bruins are sparking change for generations to come.
            </TextContainer>
            <CardsBundle isLeft data={data} img={img}/>
            <CardsBundle isTwo isRight data={data2} img={img2}/>
        </Container>
    )
}